// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1a857a5b","81":"5a69efd1","133":"ecfd9401","186":"1a07f5d5","225":"0b1a8f5a","344":"c031e828","372":"2b1caca9","377":"b145062a","681":"c2ba4b19","738":"28446639","841":"88addcc9","845":"849e7c77","856":"89d44411","858":"78ba9899","994":"7c8fa67e"}[chunkId] + ".chunk.js";
};